import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from '../hooks/useInView';

export default function Contact() {
  const [ref, inView] = useInView();
  const { t } = useTranslation();

  return (
    <section id="contact" className={`section contact${inView ? ' in-view' : ''}`} ref={ref}>
      <div className="section__container contact__inner">
        <h2 className="section__title">{t('contact.title')}</h2>
        <p className="contact__text">{t('contact.text')}</p>
        <div className="contact__links">
          <a
            href="https://github.com/eduardo-sepassos"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary"
          >
            {t('contact.github')}
          </a>
          <a
            href="https://linkedin.com/in/eduardo-passos-438528189"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--outline"
          >
            {t('contact.linkedin')}
          </a>
          <a href="mailto:eduardo.sepassos@gmail.com" className="btn btn--ghost">
            {t('contact.email')}
          </a>
        </div>
        <p className="contact__footer">{t('contact.footer')}</p>
      </div>
    </section>
  );
}
